<template>
  <div>
    <slot name="digital-signature-info">
      <p v-if="inputName">
        {{ $t(`digital-signature-info.${inputName}`, { name: signerName }) }}
      </p>
    </slot>
    <div class="mt-3" v-if="placeOfSignature">
      <strong>{{ placeOfSignature }}, {{ currentDate }}</strong>
    </div>
    <div class="gid-signature__holder border my-3">
      <vue-signature-pad
        ref="signature"
        class="gid-signature__canvas"
        saveType="image/svg+xml"
        :options="{ onEnd: signComplete }"
      />
    </div>
    <div class="gid-signature__clear-holder">
      <button class="btn btn-secondary btn-sm" @click="clearSignature">
        {{ $t('delete-signature') }}
      </button>
    </div>
  </div>
</template>

<script>
import VueSignaturePad from 'vue-signature-pad';

export default {
  components: {
    VueSignaturePad,
  },
  props: {
    placeOfSignature: String,
    ga: Object,
    inputName: {
      type: String,
      required: false,
    },
    signerName: String,
    value: undefined,
  },
  computed: {
    currentDate() {
      return this.$moment().format('L');
    },
  },
  mounted() {
    this.clearSignature();
  },
  methods: {
    signComplete() {
      const { isEmpty, data } = this.$refs.signature.saveSignature();
      this.$emit(
        'input',
        !isEmpty
          ? [
              {
                data: data.replace('data:image/svg+xml;base64,', ''),
                mimetype: 'image/svg+xml',
              },
            ]
          : null,
      );
      this.gaTrack();
    },
    clearSignature() {
      this.$refs.signature.clearSignature();
      this.$emit('input', []);
    },
    resizeCanvas() {
      this.$refs.signature.resizeCanvas();
    },
    gaTrack() {
      if (!this.ga) return;
      this.$gtag.event('Signature placed', {
        event_category: 'Document job',
        event_label: `Protocol ${this.ga.opportunityName}`,
      });
    },
  },
};
</script>

<style lang="scss">
.gid-signature__holder {
  position: relative;
  max-width: 350px;
}

.gid-signature__holder::before {
  content: '';
  display: block;
  width: 100%;
  height: 0;
  padding-bottom: 50%;
}

.gid-signature__canvas {
  position: absolute;
  top: 0;
  left: 0;
  background: #f2f2f2;
}
</style>
